import { render } from "./Footer.vue?vue&type=template&id=fcae598e"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__